import React, { FC } from 'react';
import ModalScreen from 'components/Modals/ModalScreen';
import { Formik, Form, Field, FieldArray } from 'formik';

import AskBeforeDelete from 'components/Modals/AskBeforeDelete';
import Modifers from './Modifiers';
import {
  Tabs,
  Tab,
  Container,
  ActionBar,
  Actions,
  ActionButton,
  Button,
  Row,
  Input,
  PriceInput,
  ImageInput,
  FieldsContainer,
  RightColumn,
  LeftColumn,
  Select,
  TextArea,
} from './styles';
import { Props } from './types';
import useConnect from './connect';
import { validationSchema } from './constants';

const ItemModal: FC<Props> = ({
  items,
  brandId,
  menuId,
  previousData,
  categoryOptions,
  modifiers,
  isProcessing,
}) => {
  const {
    tab,
    isConfirmRemoveOpen,
    isNew,
    allowEditImage,
    handleSubmit,
    closeModal,
    handleRemoveItem,
    askConfirmRemove,
    closeConfirmRemove,
    setDetailsTab,
    setModifierTab,
    handleUploadImage,
    uploadImageLoading,
  } = useConnect(previousData, brandId, menuId);

  return (
    <ModalScreen
      open
      title={`${isNew ? 'Add new' : 'Edit'} item`}
      handleClose={closeModal}
      showCloseButtonHeader={false}
    >
      <Formik
        initialValues={
          isNew
            ? {
                status: 'ACTIVE',
                categoryId: previousData.categoryId,
                childrenEntities: [],
                name: {
                  displayName: '',
                  printName: '',
                },
                price: '0',
                description: '',
                printDescription: '',
                imageUrl: null,
                imageUrlSmall: null,
                imageUrlMedium: null,
              }
            : previousData
        }
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ values }) => (
          <Form noValidate>
            <Tabs>
              <Tab
                label="Item details"
                selected={tab === 'details'}
                onClick={setDetailsTab}
              />
              <Tab
                label="Modifier sets"
                selected={tab === 'modifiers'}
                onClick={setModifierTab}
              />
            </Tabs>
            <Container>
              {tab === 'details' ? (
                <FieldsContainer>
                  <LeftColumn>
                    <Field
                      name="imageUrl"
                      as={ImageInput}
                      label="Image"
                      type="file"
                      disabled={!allowEditImage}
                      isLoading={uploadImageLoading}
                      onFileChange={handleUploadImage}
                    />
                  </LeftColumn>
                  <RightColumn>
                    <Row>
                      <Field
                        name="name.displayName"
                        as={Input}
                        label="Item name"
                        disabled={isProcessing}
                      />
                      <Field
                        name="name.printName"
                        as={Input}
                        label="Print name"
                        disabled={isProcessing}
                      />
                    </Row>
                    <Row>
                      <Field
                        name="categoryId"
                        as={Select}
                        label="Category"
                        options={categoryOptions}
                        disabled={isProcessing}
                      />
                      <Field
                        name="price"
                        as={PriceInput}
                        label="Add price"
                        disabled={isProcessing}
                      />
                    </Row>
                    <Field
                      name="description"
                      placeholder="Add description"
                      as={TextArea}
                      textArea
                      label="Description"
                      disabled={isProcessing}
                    />
                    <Field
                      name="printDescription"
                      placeholder="Add print description description"
                      as={TextArea}
                      textArea
                      label="Print description"
                      disabled={isProcessing}
                    />
                  </RightColumn>
                </FieldsContainer>
              ) : (
                // @ts-ignore
                <FieldArray name="childrenEntities">
                  {({ push, remove }) => (
                    <Modifers
                      push={push}
                      remove={remove}
                      childrenEntities={values.childrenEntities}
                      modifiers={modifiers}
                      items={items}
                      isProcessing={isProcessing}
                    />
                  )}
                </FieldArray>
              )}
            </Container>
            <ActionBar>
              <Actions>
                <ActionButton
                  variant="delete"
                  type="button"
                  onClick={askConfirmRemove}
                  disabled={isNew || isProcessing}
                />
                <Button
                  type="button"
                  variant="outlined"
                  color="secondary"
                  onClick={closeModal}
                  style={{ marginLeft: 'auto' }}
                >
                  Cancel
                </Button>
                <Button color="secondary" type="submit" disabled={isProcessing}>
                  Save
                </Button>
              </Actions>
            </ActionBar>
            {isConfirmRemoveOpen && !isNew && (
              <AskBeforeDelete
                message="Are you sure you want to delete this item?"
                handleRemove={handleRemoveItem}
                handleClose={closeConfirmRemove}
              />
            )}
          </Form>
        )}
      </Formik>
    </ModalScreen>
  );
};

export default ItemModal;

// TODO: TFR-29 add story to component
